/**
 * Переключатель звука.
 *
 * Единственная настройка на весь интерфейс, поэтому живёт в углу и не
 * мешает: иконка сообщает состояние, подпись для скринридера — что
 * именно произойдёт при нажатии. Состояние берётся из сервиса звука
 * через `useSyncExternalStore`, а не дублируется локальным `useState`,
 * иначе переключатель и сервис разошлись бы после перезагрузки окна.
 */

import { useSyncExternalStore } from 'react';

import {
  isSoundEnabled,
  setSoundEnabled,
  subscribeSound,
} from '../services/sound';
import { IconBell, IconBellOff } from './icons';
import { useTranslation } from 'react-i18next';

export function SoundToggle() {
  const { t } = useTranslation();
  const enabled = useSyncExternalStore(subscribeSound, isSoundEnabled, () =>
    true,
  );

  return (
    <button
      type="button"
      onClick={() => setSoundEnabled(!enabled)}
      className="pointer-events-auto flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-line bg-surface/95 text-heading shadow-soft backdrop-blur transition hover:bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
      aria-pressed={enabled}
      aria-label={enabled ? t('common.soundOff') : t('common.soundOn')}
      title={enabled ? t('common.soundEnabled') : t('common.soundDisabled')}
    >
      {enabled ? <IconBell size={18} stroke={2} aria-hidden="true" /> : <IconBellOff size={18} stroke={2} aria-hidden="true" />}
    </button>
  );
}
